import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { style: {"padding":"20px"} }
const _hoisted_4 = { style: {"padding":"20px"} }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = {
  key: 0,
  style: {"color":"#16b777"}
}
const _hoisted_10 = {
  key: 1,
  style: {"color":"#FF5722"}
}

import { ref, reactive,h, resolveComponent } from 'vue'
import { layer } from "@layui/layui-vue" 
import { allReviewWithdrawal, updateReviewState,alladminMyUserRunningDetails } from '../../api'
 


export default /*#__PURE__*/_defineComponent({
  __name: 'reviewList',
  setup(__props) {

const search = reactive({
  key: "",
})


const loading = ref(false);

const dataSource = ref([]);

const selectedKeys = ref([]);

const page = reactive({ current: 1, limit: 10, total: 0 });

const columns = ref([
  { title: "账号", key: "userName", align: "center" },
  { title: "提现金额", key: "amount", align: "center" }, 
  { title: "钱包地址", key: "uaddress", align: "center" },
  { title: "状态", key: "state", align: "center", customSlot: "state", width: "200px" },
  { title: "备注", key: "remark", align: "center" },
  { title: "审核时间", key: "reviewTime", align: "center" },
  { title: "提现时间", key: "addTime", align: "center" },
  { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center", width: "160px" }
]);


const getAllAdminUser = () => {
  loading.value = true;
  var data = { "page": page.current, "limit": page.limit, "key": search.key };
  allReviewWithdrawal(JSON.stringify(data)).then((res: any) => {
    loading.value = false;
    if (res != "" && res.code == 0) {
      dataSource.value = res.data;
      page.total = res.count;
    } else {
      dataSource.value = [];
      page.total = 0;
    }
  })
}
//获取数据
getAllAdminUser();


const change = (page: any) => {
  getAllAdminUser();
}

const sortChange = (key: any, sort: any) => {
  layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
}



//查询接口
const searchUser = () => {
  page.current = 1;
  getAllAdminUser();
}

const  changeType=(row: any,type:any)=>{
  row.state=type;
  updateUser(row);
}


const withdrawal = reactive({
    userId: "",
    id: 0,
    state: "",  
    remark:"",
    
  })
  

const updateUser = (row: any) => {
    withdrawal.userId = row.userId;
    withdrawal.id = row.id; 
    withdrawal.state = row.state; 
    withdrawal.remark = row.remark; 
    visible11.value = !visible11.value;
  }
  
  const layFormRef11 = ref();
  
  const visible11 = ref(false); 
 
  const action11 = ref([
    {
      text: "确认",
      callback: () => {
        updateReviewState(JSON.stringify(withdrawal)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllAdminUser();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
      }
    },
    {
      text: "取消",
      callback: () => {
        visible11.value = false;
  
      }
    }
  ])



  //查看流水
  const runningWaterpage = reactive({ current: 1, limit: 10, total: 0 });
  const runningWaterDataSource = ref([]);
  const runningWaterColumns = ref([
  
    { title: "余额", key: "beforeMod", align: "center"},
    { title: "收支", key: "incomeEexpen", align: "center", customSlot: "incomeEexpen"}, 
    { title: "当前余额", key: "afterMod", align: "center"},   
    { title: "类型", key: "type", align: "center", customSlot: "type" },    
    { title: "时间", key: "addTime", align: "center" }, 
]);


  const runningWater = ref(false); 


  const  checkTheRunningWater=(row:any)=>{
    runningWater.value = true;
 
    var data = { "page": runningWaterpage.current, "limit": runningWaterpage.limit, "key": row.userId };
    alladminMyUserRunningDetails(JSON.stringify(data)).then((res: any) => {
    loading.value = false;
    if (res != "" && res.code == 0) {
      runningWaterDataSource.value = res.data;
      runningWaterpage.total = res.count;
    } else {
      runningWaterDataSource.value = [];
      runningWaterpage.total = 0;
    }
  })
}


  




  const actionrunningWater = ref([
    {
      text: "关闭",
      callback: () => {
        runningWater.value = false;
      }
    }
  ])

 


return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_textarea = _resolveComponent("lay-textarea")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_form, {
                  model: search,
                  style: {"text-align":"start"},
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form_item, {
                      label: "代理账号",
                      prop: "username",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: search.key,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.key) = $event)),
                          placeholder: "请输入账号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, { mode: "inline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_button, {
                          type: "primary",
                          size: "sm",
                          onClick: searchUser
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  state: _withCtx(({ row }) => [
                    (row.state == 1)
                      ? (_openBlock(), _createBlock(_component_lay_select, {
                          key: 0,
                          modelValue: row.state,
                          "onUpdate:modelValue": ($event: any) => ((row.state) = $event)
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_select_option, {
                              value: "1",
                              label: "等审核",
                              onClick: ($event: any) => (changeType(row, 1))
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_lay_select_option, {
                              value: "2",
                              label: "通过审核",
                              onClick: ($event: any) => (changeType(row, 2))
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_lay_select_option, {
                              value: "3",
                              label: "审核失败",
                              onClick: ($event: any) => (changeType(row, 3))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"]))
                      : (row.state == 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "通过审核"))
                        : (row.state == 3)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "审核失败"))
                          : _createCommentVNode("", true)
                  ]),
                  operator: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (checkTheRunningWater(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("查看流水")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['350px', '330px'],
      btn: action11.value,
      title: "输入说明"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_lay_form, {
            model: withdrawal,
            ref_key: "layFormRef11",
            ref: layFormRef11,
            pane: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "说明",
                prop: "generalRemark"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_textarea, {
                    placeholder: "请输入说明",
                    modelValue: withdrawal.remark,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((withdrawal.remark) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"]),
    _createVNode(_component_lay_layer, {
      modelValue: runningWater.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((runningWater).value = $event)),
      shade: false,
      area: ['550px', '630px'],
      btn: actionrunningWater.value,
      title: "流水明细"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_lay_table, {
            page: runningWaterpage,
            height: '100%',
            columns: runningWaterColumns.value,
            loading: loading.value,
            "data-source": runningWaterDataSource.value,
            "selected-keys": selectedKeys.value,
            "onUpdate:selectedKeys": _cache[4] || (_cache[4] = ($event: any) => ((selectedKeys).value = $event)),
            onChange: change,
            onSortChange: sortChange
          }, {
            type: _withCtx(({ row }) => [
              (row.type==1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "充值分成"))
                : (row.type==2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "提现"))
                  : (row.type==3)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "异常订单"))
                    : (row.type==4)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "提现失败"))
                      : _createCommentVNode("", true)
            ]),
            incomeEexpen: _withCtx(({ row }) => [
              (row.type==1||row.type==4)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "+"))
                : _createCommentVNode("", true),
              (row.type==2||row.type==3)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "-"))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(row.incomeEexpen), 1)
            ]),
            operator: _withCtx(({ row }) => [
              _createVNode(_component_lay_button, {
                size: "xs",
                type: "primary",
                onClick: ($event: any) => (checkTheRunningWater(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查看流水")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})